import { _, React, classNames, withStyles, StyledProps, CentricTheme } from '@api'
import {Typography as MaterialTypography, PropTypes } from '@material-ui/core'
import {Variant} from '@material-ui/core/styles/createTypography'
import { TypographyProps } from '@material-ui/core/Typography'
import * as css from './Typography.css'

const styles = (theme: CentricTheme) => ({
  root: {
    display: 'flex'
  },
  '@keyframes loading': {
    '0%': {backgroundColor: theme.colors.grey2},
    '20%': {backgroundColor: theme.colors.grey3},
    '40%': {backgroundColor: theme.colors.grey4},
    '60%': {backgroundColor: theme.colors.grey5},
    '85%': {backgroundColor: theme.colors.grey4},
    '100%': {backgroundColor: theme.colors.grey3}
  },
  loading: {
    height: 24,
    animationDuration: `1s`,
    animationName: `loading`,
    animationIterationCount: `infinite`,
    animationTimingFunction: 'ease-out'
  }
})

interface MyProps extends StyledProps {
  loading?: boolean
  align?: PropTypes.Alignment;
  color?: PropTypes.Color | 'textPrimary' | 'textSecondary' | 'error';
  component?: React.ReactType<TypographyProps>;
  gutterBottom?: boolean;
  headlineMapping?: { [type in Variant]: string };
  noWrap?: boolean;
  paragraph?: boolean;
  variant?: Variant | 'caption' | 'button';
  title?: string
}

@(withStyles as any)(styles)
export class Typography extends React.Component<MyProps> {
  static defaultProps = {}

  render() {
    const {loading, classes, className, children, ...props} = this.props;
    return (
      <div className={classNames(className, css.root, loading ? classes.loading : '')}>
        <MaterialTypography {...props as any} children={loading ? '' : children}/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/Typography.tsx